export default __webpack_public_path__ + "static/media/5_Pep Diaz_179x177.cf6319c3.webp";